import React from 'react'

function CheckHotlineHead(props) {
    return (
        <thead className="CustomersHead">
        <tr>
            <th className='text-center'>STT</th>
            <th>Tên list check</th>
            <th>Ngày tạo</th>
            <th>Ngày check cuối</th>
            <th className='text-center'>Số lượng hotline</th>
            <th className='text-center'>Thành công</th>
            <th className='text-center'>Số trùng</th>
            <th className='text-center'>Thất bại</th>
            <th className='text-center'>Action</th>
        </tr>
        </thead>
    )
}

export default CheckHotlineHead